// Module
var code = "<h1 id=\"见证人\">见证人</h1> <p>见证人是为区块链打包生成新的区块的实体。每一个见证人由股东批准，打包经验证的交易，生成并签署区块。每一条进入网络的交易最终将被所有见证人验证。</p> <h2 id=\"共识机制\">共识机制</h2> <p>由谁在什么时间来<em>打包生成</em>区块是由被称为<em>Delegated Proof of Stak (DPOS)</em>的共识算法决定的。算法的本质是 BitShares 的股东(BTS的持有者)能通过投票来决定他们期望的块打包者。由获得最多票数的所谓&quot;见证人&quot;来打包生成区块。</p> ";
// Exports
export default code;